import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { Box, Button, Card, Drawer, Grid, List, ListItemButton, ListItemText, Stack, Typography, useTheme, } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import componentSamples from "./MuiComponent/index";
export const ThemeScreen = () => {
    const [activeId, setActiveId] = useState(null);
    const sectionRefs = useRef({});
    const theme = useTheme();
    // Add Theme JSON as the first item in the component samples list
    const themeJsonSample = {
        id: "ThemeJSON",
        title: "Current Theme Configuration",
        component: (_jsx(Box, Object.assign({ sx: { maxHeight: 600, overflow: "auto", backgroundColor: "#f5f5f5", p: 2, borderRadius: 1 } }, { children: _jsx(Typography, Object.assign({ variant: "body2", component: "pre", sx: { whiteSpace: "pre-wrap", fontFamily: "monospace", fontSize: "0.75rem" } }, { children: JSON.stringify(theme, null, 2) })) }))),
        docs: null,
    };
    const allSamples = [...componentSamples, themeJsonSample];
    // Set refs for each section
    useEffect(() => {
        sectionRefs.current = {};
        allSamples.forEach(({ id }) => {
            sectionRefs.current[id] = document.getElementById(id);
        });
    }, []);
    // Scrollspy logic
    useEffect(() => {
        const handleScroll = () => {
            let current = null;
            for (const { id } of allSamples) {
                const el = document.getElementById(id);
                if (el) {
                    const rect = el.getBoundingClientRect();
                    if (rect.top <= 100) {
                        current = id;
                    }
                }
            }
            setActiveId(current);
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return (_jsxs(Box, Object.assign({ sx: { display: "flex" } }, { children: [_jsx(Drawer, Object.assign({ variant: "permanent", sx: {
                    width: 220,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: 220, boxSizing: "border-box" },
                }, anchor: "left" }, { children: _jsx(List, { children: allSamples.map(({ id, title }) => (_jsx(ListItemButton, Object.assign({ selected: activeId === id, onClick: () => {
                            const el = document.getElementById(id);
                            if (el)
                                el.scrollIntoView({ behavior: "smooth", block: "start" });
                        } }, { children: _jsx(ListItemText, { primary: title }) }), id))) }) })), _jsx(Stack, Object.assign({ gap: 1 }, { children: allSamples.map(({ id: _id, title, component, docs }) => (_jsxs(Card, Object.assign({ id: _id, sx: { p: 2, mb: 2 } }, { children: [_jsxs(Grid, Object.assign({ container: true, sx: {
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 2,
                            } }, { children: [_jsx(Typography, Object.assign({ variant: "h2", gutterBottom: true }, { children: title })), docs ? (_jsx(Button, Object.assign({ variant: "outlined", color: "secondary", size: "small", href: docs, target: "_blank", rel: "noreferrer" }, { children: "MUI Docs" }))) : (_jsx(Button, Object.assign({ variant: "outlined", color: "secondary", size: "small", endIcon: _jsx(ThumbUpIcon, {}) }, { children: _id === "ThemeJSON" ? "Theme Data" : "Custom Component" })))] })), _jsx(Box, Object.assign({ sx: {
                                mb: 10,
                                pl: 1,
                                m: "auto",
                            } }, { children: component }))] }), _id))) }))] })));
};
